<script setup>
import { computed, ref, watch } from 'vue';
import usuarios from '@/api/usuarios';
import Spinner from '@/components/Spinner.vue';
import ModalSimple from '@/components/ModalSimple.vue';
import apiPanelPerfilSalida from '@/api/cifra/lomloe/panel_perfil_salida';
import PerfilSalidaChart from './PerfilSalidaChart.vue';

const props = defineProps({
  idGrupo: { type: Number, required: true },
  // Realmente es obligatorio pero en el panel se carga solo un modal (sin idAlumno)
  // y luego se le asigna el idAlumno al abrirlo porque si no serían muchos modales y 
  // ralentizaría la carga de la página mucho (y memoria)
  idAlumno: { type: Number, default: null },
});

const show = defineModel('show');

const emits = defineEmits(['cargado', 'cerrado']);

const cargando = ref(false);
const perfilSalida = ref();
const alumno = computed(() => perfilSalida.value?.alumno);

function loadData(data) {
  perfilSalida.value = data;
  emits('cargado', data);
}

function reset() {
  perfilSalida.value = null;
}

async function cargarDatos() {
  cargando.value = true;
  try {
    const result = await apiPanelPerfilSalida.perfilSalidaAlumno(
      props.idGrupo, props.idAlumno,
    );
    loadData(result.data);
  } catch (error) {
    console.error(error);
  } finally {
    cargando.value = false;
  }
}

watch(show, (visible) => {
  if (visible) {
    cargarDatos();
  } else {
    reset();
    emits('cerrado');
  }
});
</script>

<template>
  <teleport to="body">
    <ModalSimple
      v-model="show"
      :mostrar-boton-cerrar="true"
      tamano="lg"
    >
      <Spinner v-if="cargando" />
      <div v-if="!cargando && alumno">
        <thumbnail-header
          :imagen="alumno.foto_url"
          :titulo="usuarios.fullname(alumno)"
          :subtitulo="$t('perfil_salida')"
          class="m-b border-bottom-cifra p-b-sm"
        />
        <PerfilSalidaChart :perfil-salida="perfilSalida"></PerfilSalidaChart>
      </div>
    </ModalSimple>
  </teleport>
</template>

<style lang="scss" scoped>
  .titulo-seccion small{
    display: block;
    font-size: 0.6em;
  }
</style>
